import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';

interface ApiResponse<T> {
  value: T;
}
interface QueryPagoFacturaWeb {
  rut: string | undefined;
}

interface IResponse {
  ok: boolean;
}

export const tieneCredito = async (
  query: QueryPagoFacturaWeb
): Promise<IResponse> => {
  try {
    const res = await apiClient.post<ApiResponse<IResponse>>(
      Endpoints.TieneCredito,
      {
        rut: query.rut,
      }
    );
    return res.data.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
